/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IotDeviceStateOfUse = {
    Unknown: 'Unknown',
    Offline: 'Offline',
    Initializing: 'Initializing',
    Measuring: 'Measuring',
    DeviceError: 'DeviceError',
    Online: 'Online'
} as const;
export type IotDeviceStateOfUse = typeof IotDeviceStateOfUse[keyof typeof IotDeviceStateOfUse];


export function IotDeviceStateOfUseFromJSON(json: any): IotDeviceStateOfUse {
    return IotDeviceStateOfUseFromJSONTyped(json, false);
}

export function IotDeviceStateOfUseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IotDeviceStateOfUse {
    return json as IotDeviceStateOfUse;
}

export function IotDeviceStateOfUseToJSON(value?: IotDeviceStateOfUse | null): any {
    return value as any;
}

/**
 * Check if a given object implements the IotDeviceStateOfUse interface.
 */
 export function instanceOfIotDeviceStateOfUse(value: any): value is IotDeviceStateOfUse {
    return Object.values(IotDeviceStateOfUse).includes(value)
}

